import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useRef, forwardRef } from 'react';
import { string, array, shape, func, oneOf, object, bool, oneOfType, number } from 'prop-types';
import { Container } from './showcase.styles';
import exhibitions from './exhibitions';
export const Showcase = /*#__PURE__*/forwardRef((props, ref) => {
  var _ref;

  const {
    data,
    onClick,
    onMouseDown,
    onProductView,
    jsonLD,
    exhibition,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showFullListBtn,
    showMoreBtn,
    onClickLoadMore,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    showSponsoredSubTitle,
    slidesPerViewBetterOffer,
    showButton,
    buttonProps
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["data", "onClick", "onMouseDown", "onProductView", "jsonLD", "exhibition", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showFullListBtn", "showMoreBtn", "onClickLoadMore", "showInCashInfo", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "slidesPerViewBetterOffer", "showButton", "buttonProps"]);

  (_ref = ref) !== null && _ref !== void 0 ? _ref : ref = useRef(null);
  const Exhibition = exhibitions[exhibition] === undefined ? exhibitions.rank : exhibitions[exhibition];
  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref,
    exhibition: exhibition
  }, rest), /*#__PURE__*/React.createElement(Exhibition, _extends({
    data: data.products,
    title: data.title,
    highlight: data.highlight,
    button: data.button,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onProductView: onProductView,
    jsonLD: jsonLD,
    titleAs: titleAs,
    titleSize: titleSize,
    productTitleAs: productTitleAs,
    imageAltPrefix: imageAltPrefix,
    showFullListBtn: showFullListBtn,
    slidesPerViewBetterOffer: slidesPerViewBetterOffer,
    showMoreBtn: showMoreBtn,
    onClickLoadMore: onClickLoadMore,
    showInCashInfo: showInCashInfo,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showSponsoredSubTitle: showSponsoredSubTitle,
    showButton: showButton,
    buttonProps: buttonProps
  }, rest)));
});
Showcase.defaultProps = {
  data: {
    title: null,
    products: []
  },
  onClick: () => false,
  onMouseDown: () => false,
  onProductView: () => {},
  exhibition: 'rank',
  jsonLD: true,
  titleAs: 'h2',
  productTitleAs: 'h3',
  imageAltPrefix: '',
  showFullListBtn: false,
  showMoreBtn: false,
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: false,
  showSponsoredSubTitle: false,
  slidesPerViewBetterOffer: 2,
  showButton: false,
  buttonProps: {}
};
process.env.NODE_ENV !== "production" ? Showcase.propTypes = {
  data: shape({
    button: object,
    highlight: object,
    title: string,
    products: array.isRequired
  }).isRequired,
  exhibition: oneOf(['carousel', 'rank', 'list', 'highlight', 'button', 'betteroffer']),
  onClick: func.isRequired,
  onMouseDown: func,
  onProductView: func,
  jsonLD: bool,
  titleAs: string,
  titleSize: oneOfType([string, number]),
  productTitleAs: string,
  imageAltPrefix: string,
  showFullListBtn: bool,
  showMoreBtn: bool,
  onClickLoadMore: func,
  showInCashInfo: bool,
  showDiscount: bool,
  showDiscountOnlyCashInfo: bool,
  showSponsoredSubTitle: true,
  slidesPerViewBetterOffer: number,
  showButton: bool,
  buttonProps: shape({})
} : void 0;
Showcase.displayName = 'Showcase';
export default Showcase;